// Cross-origin auth fallback.
//
// On production, the custom domain (e.g. www.bulkusedtires.com) and the app's
// hosting domain (e.g. *.emergent.host) are different origins from the
// browser's point of view, even when /api requests are proxied to the same
// backend. Modern browsers increasingly refuse to persist/send third-party
// SameSite=None cookies across that origin split, which breaks the normal
// httpOnly-cookie session right after a successful login/register.
//
// As a resilient fallback (not a replacement — cookies still work fine for
// same-origin/preview), the login/register endpoints also return the raw
// access_token in the JSON body. We stash it in sessionStorage (survives
// page reloads in the same tab, cleared on tab close) and a global axios
// interceptor (see axiosAuthInterceptor.js) attaches it as an
// `Authorization: Bearer` header on every request, so auth keeps working
// even if the cookie never makes it to the browser's jar.

const CLIENT_TOKEN_KEY = 'but_client_token';
const ADMIN_TOKEN_KEY = 'but_admin_token';

export const setClientToken = (token) => sessionStorage.setItem(CLIENT_TOKEN_KEY, token);
export const getClientToken = () => sessionStorage.getItem(CLIENT_TOKEN_KEY);
export const clearClientToken = () => sessionStorage.removeItem(CLIENT_TOKEN_KEY);

export const setAdminToken = (token) => sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
export const getAdminToken = () => sessionStorage.getItem(ADMIN_TOKEN_KEY);
export const clearAdminToken = () => sessionStorage.removeItem(ADMIN_TOKEN_KEY);
